import Icon, { Icons } from '../../elements/Icon';

const CreateInventoryPositionLoading = () => {
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 gap-8 relative">
      <div className="md:col-span-2 flex items-center justify-center bg-gray-100 border border-gray-300 rounded-md p-8">
        <Icon
          name={Icons.SPINNER_GAP}
          className="animate-spin text-gray-400"
          size={24}
        />
      </div>
      <div>
        <div className="bg-gray-50 border border-gray-300 rounded-md p-6 flex justify-center items-center">
          <Icon
            name={Icons.SPINNER_GAP}
            className="animate-spin text-gray-400"
            size={24}
          />
        </div>
      </div>
    </div>
  );
};

export default CreateInventoryPositionLoading;
